import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import isEmpty from "validator/lib/isEmpty"
import isMobilePhone from "validator/lib/isMobilePhone"
import { useTranslation } from "react-i18next"

import { Button } from "components"
import { addAddress, editAddress } from "services"
import { changeDeliveryAddress } from "@redux"
import classes from "./CdsamFormFooter.module.scss"
import clsx from "clsx"

const CdsamFormFooter = props => {
  const {
    form,
    setForm,
    setModalContent,
    setFormErrors,
    addressForEdit,
    setSelectedAddress,
    setAddressForEdit,
    setUserAddresses,
    initialFormErrorsState,
    selectedUserAccount,
    isGuestOrder,
    setOpenMapAddressModal
  } = props

  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const selectedCashierBranch =
    useSelector(state =>
      state.userAccountInfo.selectedCashierBranch
    )

  const [sending, setSending] = useState(false)

  const validate = () => {
    const errors = { ...initialFormErrorsState }
    let result = true

    if (isEmpty(form.address)) {
      errors.address = t("آدرس_الزامی_است")
      result = false
    } else if (form.address.length < 10) {
      errors.address = t("آدرس_کوتاه_است")
      result = false
    } else if (form.address.length > 150) {
      errors.address = t("آدرس_طولانی_است")
      result = false
    }

    if (!selectedCashierBranch.customerAddressRules.onlyFromBranchStateAndCity) {
      if (isEmpty(form.city)) {
        errors.city = t("شهر_الزامی_است")
        result = false
      }

      if (isEmpty(form.state)) {
        errors.state = t("استان_الزامی_است")
        result = false
      }
    }

    if (
      !!form.recipientPhoneNumber &&
      !isMobilePhone(`+98${form.recipientPhoneNumber.slice(1)}`, ["fa-IR"], { strictMode: true })
    ) {
      errors.recipientPhoneNumber = t("شماره_موبایل_گیرنده_اشتباه_است")
      result = false
    }

    if (!form.coordinates[0]) {
      errors.coordinates = t("لطفا_موقعیت_خود_را_روی_نقشه_تایین_کنید")
      result = false
    }

    setFormErrors({ ...errors })

    return result
  }

  const getRequestData = () => {
    const data = {
      accountId: selectedUserAccount._id,
      address: form.address,
      note: form.note,
      city: form.city || " ",
      state: form.state || " ",
      zipCode: form.zipCode || " ",
      country: "ایران",
      recipientName: form.recipientName,
      recipientPhoneNumber:
        !!form.recipientPhoneNumber.trim()
          ? `+98${form.recipientPhoneNumber.slice(1)}`
          : "",
      location: {
        type: "Point",
        coordinates: [
          form.coordinates[0],
          form.coordinates[1]
        ]
      }
    }

    if (selectedCashierBranch.customerAddressRules.onlyFromBranchStateAndCity) {
      data["city"] = selectedCashierBranch.city

      data["state"] = selectedCashierBranch.state
    }

    return data
  }

  const handleAddAddress = async () => {
    if (!validate()) return

    setSending(true)


    const data = getRequestData()

    try {
      const response =
        await addAddress(
          data,
          { accountId: selectedUserAccount._id }
        )

      setUserAddresses(prev => [...prev, response])

      setSelectedAddress(response)

      setModalContent("addresses")
    } catch (err) {
      console.log(err)
      setSending(false)
    }
  }

  const handleEditGuestAddress = () => {
    if (!validate()) return

    const data = {
      address: form.address,
      note: form.note,
      city: form.city || " ",
      state: form.state || " ",
      zipCode: form.zipCode || " ",
      country: "ایران",
      recipientName: form.recipientName,
      recipientPhoneNumber:
        !!form.recipientPhoneNumber.trim()
          ? `+98${form.recipientPhoneNumber.slice(1)}`
          : ""
      ,
      location: {
        type: "Point",
        coordinates: [
          form.coordinates[0],
          form.coordinates[1]
        ]
      }
    }

    dispatch(
      changeDeliveryAddress(data)
    )

    setOpenMapAddressModal(false)
  }

  const handleEditAddress = async () => {
    if (!validate()) return

    setSending(true)

    const data = getRequestData()

    try {
      const response =
        await editAddress(
          addressForEdit._id,
          data,
          { accountId: selectedUserAccount._id }
        )

      setUserAddresses(prev =>
        prev.map(address =>
          address._id === addressForEdit._id
            ? response
            : address
        )
      )

      setSelectedAddress(response)

      setAddressForEdit(null)

      setModalContent("addresses")
    } catch (err) {
      console.log(err)

      setSending(false)
    }
  }

  const handleGoBack = () => {
    setForm({ ...initialFormErrorsState })

    setAddressForEdit(null)

    if (isGuestOrder) return setOpenMapAddressModal(false)

    setModalContent("addresses")
  }

  const editMode = !!addressForEdit

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["container"]}>
      <Button
        color="success"
        loading={sending}
        onClick={editMode
          ? isGuestOrder ? handleEditGuestAddress : handleEditAddress
          : handleAddAddress
        }
      >
        {t("ذخیره")}
      </Button>

      <Button
        onClick={handleGoBack}
        color="danger"
        className={clsx(
          classes["button"],
          isLtr && classes["button-ltr"]
        )}
      >
        {t("بازگشت")}
      </Button>
    </div >
  )
}

export default CdsamFormFooter